/**
 *
 * NudgeAlert
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Space, Conditional, Text, Button } from '@cashfree-intl/coherent';

import backgroundImage from '../../images/nudge-bg.svg';

import './style.scss';

const styleProps = {
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};

function NudgeAlert({
  label,
  iconSrc,
  title,
  success,
  alert,
  description,
  buttonText,
  buttonId,
  onButtonClick,
  metaData,
  // iconProps = {},
}) {
  const getTitleColor = () => {
    if (success) return 'marketingSecondary';
    if (alert) return 'warning';
    return 'white';
  };

  // const showMeta = metaData && metaData.length > 0;

  const onClick = () => onButtonClick(buttonId);

  return (
    <div className="nudge-alert pt-3 pb-3 pl-4 pr-4" style={styleProps}>
      <Conditional if={label}>
        <Text variant="b12" strong className="mb-2 nudge-label">
          {label}
        </Text>
      </Conditional>
      <Space alignItems="center" justifyContent="space-between">
        <Space alignItems="flex-start" className="nudge-alert-content">
          <Conditional if={iconSrc}>
            <div className="mr-2">
              <img src={iconSrc} alt="Nudge-Icon" />
            </div>
          </Conditional>
          <div>
            <Conditional if={title}>
              <Text
                variant="h20"
                strong
                color={getTitleColor()}
                className="mb-1"
              >
                {title}
              </Text>
            </Conditional>
            <Conditional if={description}>
              <Text variant="h16" color="white" className="mb-2">
                {description}
              </Text>
            </Conditional>
            {metaData && metaData.length > 0 && (
              <Space alignItems="center" className="mt-3 meta-data-group">
                {metaData.map(obj => (
                  <Space
                    key={obj.iconURL}
                    alignItems="center"
                    className="meta-data-item"
                  >
                    <img src={obj.iconURL} alt="nudge-meta-data-icon" />
                    <Text className="ml-1" variant="h16" strong color="white">
                      {obj.text}
                    </Text>
                  </Space>
                ))}
              </Space>
            )}
          </div>
        </Space>
        <Conditional if={buttonText}>
          <Button onClick={onClick} className="ml-2">
            <Text variant="b14" color="primary" strong>
              {buttonText}
            </Text>
          </Button>
        </Conditional>
      </Space>
    </div>
  );
}

NudgeAlert.propTypes = {
  label: PropTypes.string,
  iconSrc: PropTypes.string,
  title: PropTypes.string,
  success: PropTypes.bool,
  alert: PropTypes.bool,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  buttonId: PropTypes.string,
  onButtonClick: PropTypes.func,
  metaData: PropTypes.array,
  // iconProps: PropTypes.object,
};

export default memo(NudgeAlert);
